import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getPrivateRedEnvelopeAction,
  getRedEnvelopeAction,
  getRedEnvelopeRecordAction,
  getTransferMoneyRecordAction,
} from "../action/systemPayAction";

export const systemPayReducer = (
  builder: ActionReducerMapBuilder<{
    redEnvelopeList: any;
    redEnvelopeDetail: any;
    privateRedEnvelope: any;
    transferMoneyRecord: any;
  }>
) => {
  builder.addCase(getRedEnvelopeAction.fulfilled, (state, { payload }) => {
    console.log(payload);
    state.redEnvelopeList = payload;
  });
  builder.addCase(
    getRedEnvelopeRecordAction.fulfilled,
    (state, { payload }) => {
      state.redEnvelopeDetail = payload;
    }
  );

  builder.addCase(
    getPrivateRedEnvelopeAction.fulfilled,
    (state, { payload }) => {
      console.log(payload);
      state.privateRedEnvelope = payload;
    }
  );

  builder.addCase(
    getTransferMoneyRecordAction.fulfilled,
    (state, { payload }) => {
      console.log(payload);
      state.transferMoneyRecord = payload;
    }
  );
};
